export const printPdfPageAttribute = 'data-print-pdf-page';
